export const getBelgianCandidates = () => [
  {
    name: "Mathijs Verhoeven",
    email: "mathijs.verhoeven@gmail.com",
    phone: "+32 471 234 567",
    function: "Full Stack Developer",
    skills: ["JavaScript", "React", "Node.js", "TypeScript"],
    manager: "Sofie Martens",
    status: "Looking",
    ai_synthesis: "Experienced full stack developer with strong React and Node.js skills seeking new challenges in a dynamic tech environment."
  },
  {
    name: "Elise Peeters",
    email: "elise.peeters@outlook.be",
    phone: "+32 472 345 678",
    function: "UX/UI Designer",
    skills: ["Figma", "Adobe XD", "User Research", "Prototyping"],
    manager: "Thomas De Vos",
    status: "Open",
    ai_synthesis: "Creative UX/UI designer with proven ability to create intuitive, user-friendly interfaces through research-driven methodologies."
  },
  {
    name: "Thomas Janssens",
    email: "thomas.janssens@hotmail.com",
    phone: "+32 473 456 789",
    function: "DevOps Engineer",
    skills: ["Docker", "Kubernetes", "AWS", "CI/CD"],
    manager: "Emma Claes",
    status: "Looking",
    ai_synthesis: "Detail-oriented DevOps engineer with expertise in containerization and cloud infrastructure management."
  },
  {
    name: "Charlotte Maes",
    email: "charlotte.maes@gmail.com",
    phone: "+32 474 567 890",
    function: "Frontend Developer",
    skills: ["React", "Vue.js", "CSS", "HTML"],
    manager: "Willem Van den Berg",
    status: "Looking",
    ai_synthesis: "Passionate frontend developer specializing in creating responsive, accessible web applications with modern frameworks."
  },
  {
    name: "Nicolas Dubois",
    email: "nicolas.dubois@outlook.be",
    phone: "+32 475 678 901",
    function: "Backend Developer",
    skills: ["Java", "Spring Boot", "Hibernate", "SQL"],
    manager: "Sofie Martens",
    status: "Unavailable",
    ai_synthesis: "Seasoned backend developer with extensive experience building scalable enterprise applications using Java and Spring Boot."
  },
  {
    name: "Emilie Vandenberghe",
    email: "emilie.vandenberghe@gmail.com",
    phone: "+32 476 789 012",
    function: "Data Scientist",
    skills: ["Python", "R", "Machine Learning", "TensorFlow"],
    manager: "Lucas Vermeulen",
    status: "Open",
    ai_synthesis: "Analytical data scientist with strong mathematical background and expertise in developing predictive models."
  },
  {
    name: "Lucas De Smet",
    email: "lucas.desmet@hotmail.com",
    phone: "+32 477 890 123",
    function: "Mobile Developer",
    skills: ["Swift", "Kotlin", "React Native", "Flutter"],
    manager: "Emma Claes",
    status: "Looking",
    ai_synthesis: "Versatile mobile developer proficient in both native and cross-platform development frameworks for iOS and Android."
  },
  {
    name: "Sophie Van der Linden",
    email: "sophie.vanderlinden@gmail.com",
    phone: "+32 478 901 234",
    function: "Product Manager",
    skills: ["Agile", "Scrum", "Product Strategy", "User Stories"],
    manager: "Willem Van den Berg",
    status: "Open",
    ai_synthesis: "Strategic product manager with a track record of successfully launching digital products through agile methodologies."
  },
  {
    name: "Maxime Leroy",
    email: "maxime.leroy@outlook.be",
    phone: "+32 479 012 345",
    function: "QA Engineer",
    skills: ["Selenium", "Jest", "Manual Testing", "Test Automation"],
    manager: "Thomas De Vos",
    status: "Looking",
    ai_synthesis: "Thorough QA engineer experienced in developing comprehensive test strategies for web applications."
  },
  {
    name: "Claire Wouters",
    email: "claire.wouters@gmail.com",
    phone: "+32 470 123 456",
    function: "Project Manager",
    skills: ["Prince2", "MS Project", "Risk Management", "Stakeholder Management"],
    manager: "Sofie Martens",
    status: "Unavailable",
    ai_synthesis: "Organized project manager skilled at coordinating cross-functional teams and ensuring project delivery within constraints."
  },
    {
      name: "Louis Mertens",
      email: "louis.mertens@hotmail.com",
      phone: "+32 471 234 567",
      function: "Systems Architect",
      skills: ["System Design", "Microservices", "Cloud Architecture", "AWS"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Innovative systems architect with deep knowledge of distributed systems and cloud-native architectures."
    },
    {
      name: "Julie Van Damme",
      email: "julie.vandamme@gmail.com",
      phone: "+32 472 345 678",
      function: "Content Strategist",
      skills: ["Content Planning", "SEO", "Copywriting", "Analytics"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Creative content strategist with expertise in developing engaging, SEO-optimized content for digital platforms."
    },
    {
      name: "Victor Jacobs",
      email: "victor.jacobs@outlook.be",
      phone: "+32 473 456 789",
      function: "Security Analyst",
      skills: ["Penetration Testing", "OWASP", "Cryptography", "Security Audits"],
      manager: "Willem Van den Berg",
      status: "Open",
      ai_synthesis: "Detail-oriented security analyst proficient in identifying vulnerabilities and implementing robust security solutions."
    },
    {
      name: "Camille Lambert",
      email: "camille.lambert@gmail.com",
      phone: "+32 474 567 890",
      function: "Business Analyst",
      skills: ["Requirements Gathering", "UML", "Process Modeling", "Data Analysis"],
      manager: "Thomas De Vos",
      status: "Looking",
      ai_synthesis: "Analytical business analyst experienced in translating business needs into technical requirements for development teams."
    },
    {
      name: "Alexandre Claes",
      email: "alexandre.claes@hotmail.com",
      phone: "+32 475 678 901",
      function: "Technical Writer",
      skills: ["Documentation", "API Docs", "Markdown", "Technical Communication"],
      manager: "Sofie Martens",
      status: "Unavailable",
      ai_synthesis: "Precise technical writer capable of creating clear, comprehensive documentation for complex technical products."
    },
    {
      name: "Eva Willems",
      email: "eva.willems@gmail.com",
      phone: "+32 476 789 012",
      function: "Cloud Engineer",
      skills: ["AWS", "Azure", "Terraform", "CloudFormation"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Skilled cloud engineer with extensive experience designing and implementing secure, scalable cloud infrastructure."
    },
    {
      name: "Simon Goossens",
      email: "simon.goossens@outlook.be",
      phone: "+32 477 890 123",
      function: "Database Administrator",
      skills: ["SQL Server", "PostgreSQL", "MongoDB", "Database Optimization"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Experienced database administrator specializing in performance tuning and high-availability database environments."
    },
    {
      name: "Nathalie Van den Bossche",
      email: "nathalie.vandenbossche@gmail.com",
      phone: "+32 478 901 234",
      function: "Agile Coach",
      skills: ["Scrum", "Kanban", "Team Facilitation", "Change Management"],
      manager: "Willem Van den Berg",
      status: "Open",
      ai_synthesis: "Empathetic agile coach adept at transforming traditional teams into high-performing agile units through mentoring and coaching."
    },
    {
      name: "Arthur Verbeke",
      email: "arthur.verbeke@hotmail.com",
      phone: "+32 479 012 345",
      function: "Data Engineer",
      skills: ["Spark", "Hadoop", "ETL", "Data Pipelines"],
      manager: "Thomas De Vos",
      status: "Looking",
      ai_synthesis: "Resourceful data engineer experienced in building robust data pipelines and infrastructures for large-scale data processing."
    },
    {
      name: "Florence Dumont",
      email: "florence.dumont@gmail.com",
      phone: "+32 470 123 456",
      function: "UI Developer",
      skills: ["JavaScript", "CSS", "SASS", "Responsive Design"],
      manager: "Sofie Martens",
      status: "Unavailable",
      ai_synthesis: "Creative UI developer with strong design sensibilities and expertise in building pixel-perfect interfaces."
    },
    {
      name: "Jonathan Dewilde",
      email: "jonathan.dewilde@outlook.be",
      phone: "+32 471 234 567",
      function: "Software Architect",
      skills: ["Design Patterns", "Microservices", "API Design", "System Integration"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Forward-thinking software architect with proven ability to design scalable, maintainable software systems."
    },
    {
      name: "Laura Martens",
      email: "laura.martens@gmail.com",
      phone: "+32 472 345 678",
      function: "Solution Architect",
      skills: ["Enterprise Architecture", "Solution Design", "Integration", "Azure"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Strategic solution architect specializing in designing comprehensive enterprise solutions addressing complex business needs."
    },
    {
      name: "David Vermeersch",
      email: "david.vermeersch@hotmail.com",
      phone: "+32 473 456 789",
      function: "Network Engineer",
      skills: ["Cisco", "Routing", "Switching", "Network Security"],
      manager: "Willem Van den Berg",
      status: "Open",
      ai_synthesis: "Reliable network engineer with extensive experience designing and managing enterprise network infrastructure."
    },
    {
      name: "Isabelle Thijs",
      email: "isabelle.thijs@gmail.com",
      phone: "+32 474 567 890",
      function: "Technical Support Specialist",
      skills: ["Troubleshooting", "Customer Service", "Technical Documentation", "System Administration"],
      manager: "Thomas De Vos",
      status: "Looking",
      ai_synthesis: "Patient technical support specialist skilled at resolving complex technical issues while providing excellent customer service."
    },
    {
      name: "Marc Declercq",
      email: "marc.declercq@outlook.be",
      phone: "+32 475 678 901",
      function: "Test Automation Engineer",
      skills: ["Selenium", "Cypress", "Jenkins", "Test Frameworks"],
      manager: "Sofie Martens",
      status: "Unavailable",
      ai_synthesis: "Meticulous test automation engineer focused on creating maintainable, reliable automated test suites."
    },
    {
      name: "Céline Mathieu",
      email: "celine.mathieu@gmail.com",
      phone: "+32 476 789 012",
      function: "Web Developer",
      skills: ["PHP", "Laravel", "MySQL", "JavaScript"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Versatile web developer experienced in building robust web applications using modern PHP frameworks."
    },
    {
      name: "Vincent Peeters",
      email: "vincent.peeters@hotmail.com",
      phone: "+32 477 890 123",
      function: "DevSecOps Engineer",
      skills: ["CI/CD", "Security Automation", "Infrastructure as Code", "Compliance as Code"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Security-conscious DevSecOps engineer specializing in integrating security practices into development and operations processes."
    },
    {
      name: "Aurélie Lejeune",
      email: "aurelie.lejeune@gmail.com",
      phone: "+32 478 901 234",
      function: "Scrum Master",
      skills: ["Agile", "Scrum", "Facilitation", "Continuous Improvement"],
      manager: "Willem Van den Berg",
      status: "Open",
      ai_synthesis: "Dedicated Scrum Master proficient in removing impediments and facilitating agile ceremonies to maximize team productivity."
    },
    {
      name: "Sébastien Vandermeiren",
      email: "sebastien.vandermeiren@outlook.be",
      phone: "+32 479 012 345",
      function: "Java Developer",
      skills: ["Java", "Spring", "Hibernate", "Microservices"],
      manager: "Thomas De Vos",
      status: "Looking",
      ai_synthesis: "Experienced Java developer with expertise in building enterprise applications using Spring Framework."
    },
    {
      name: "Sarah Vermeulen",
      email: "sarah.vermeulen@gmail.com",
      phone: "+32 470 123 456",
      function: ".NET Developer",
      skills: ["C#", "ASP.NET", "Entity Framework", "Azure"],
      manager: "Sofie Martens",
      status: "Unavailable",
      ai_synthesis: "Proficient .NET developer with strong skills in building scalable web applications and cloud-based solutions."
    },
    {
      name: "Olivier Dupont",
      email: "olivier.dupont@hotmail.com",
      phone: "+32 471 234 567",
      function: "IT Project Manager",
      skills: ["Project Management", "Agile", "Budgeting", "Resource Planning"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Goal-oriented IT project manager with proven track record of delivering complex projects on time and within budget."
    },
    {
      name: "Margot Verstraeten",
      email: "margot.verstraeten@gmail.com",
      phone: "+32 472 345 678",
      function: "Digital Marketing Specialist",
      skills: ["SEO", "SEM", "Analytics", "Content Marketing"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Results-driven digital marketing specialist with expertise in developing data-driven marketing strategies."
    },
    {
      name: "Arnaud Lefebvre",
      email: "arnaud.lefebvre@outlook.be",
      phone: "+32 473 456 789",
      function: "System Administrator",
      skills: ["Linux", "Windows Server", "Automation", "Scripting"],
      manager: "Willem Van den Berg",
      status: "Open",
      ai_synthesis: "Dedicated system administrator experienced in managing complex server environments and implementing automation."
    },
    {
      name: "Zoé Lambert",
      email: "zoe.lambert@gmail.com",
      phone: "+32 474 567 890",
      function: "Business Intelligence Analyst",
      skills: ["Power BI", "SQL", "Data Visualization", "ETL"],
      manager: "Thomas De Vos",
      status: "Looking",
      ai_synthesis: "Analytical BI analyst skilled at transforming complex data into actionable insights through visualization and reporting."
    },
    {
      name: "Julien Devos",
      email: "julien.devos@hotmail.com",
      phone: "+32 475 678 901",
      function: "AI Engineer",
      skills: ["Python", "TensorFlow", "Machine Learning", "NLP"],
      manager: "Sofie Martens",
      status: "Unavailable",
      ai_synthesis: "Innovative AI engineer specializing in developing NLP models and implementing machine learning solutions for business problems."
    },
    {
      name: "Louise Claessens",
      email: "louise.claessens@gmail.com",
      phone: "+32 476 789 012",
      function: "Cybersecurity Specialist",
      skills: ["Network Security", "Ethical Hacking", "Threat Analysis", "SIEM"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Vigilant cybersecurity specialist experienced in threat detection and implementing security controls across enterprise environments."
    },
    {
      name: "Maxime De Clerck",
      email: "maxime.declerck@outlook.be",
      phone: "+32 477 890 123",
      function: "Python Developer",
      skills: ["Python", "Django", "Flask", "FastAPI"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Skilled Python developer with expertise in web frameworks and API development for complex business applications."
    },
    {
      name: "Emma Vandenbroucke",
      email: "emma.vandenbroucke@gmail.com",
      phone: "+32 478 901 234",
      function: "ERP Consultant",
      skills: ["SAP", "Oracle ERP", "Business Process", "Requirements Analysis"],
      manager: "Willem Van den Berg",
      status: "Open",
      ai_synthesis: "Knowledgeable ERP consultant with deep understanding of business processes and system implementation methodologies."
    },
    {
      name: "Matthieu Pauwels",
      email: "matthieu.pauwels@hotmail.com",
      phone: "+32 479 012 345",
      function: "SRE Engineer",
      skills: ["Monitoring", "Incident Response", "Performance Tuning", "Reliability"],
      manager: "Thomas De Vos",
      status: "Looking",
      ai_synthesis: "Diligent SRE engineer focused on building resilient systems and improving operational reliability through automation."
    },
    {
      name: "Chloé Maes",
      email: "chloe.maes@gmail.com",
      phone: "+32 470 123 456",
      function: "Blockchain Developer",
      skills: ["Solidity", "Ethereum", "Smart Contracts", "Web3"],
      manager: "Sofie Martens",
      status: "Unavailable",
      ai_synthesis: "Forward-thinking blockchain developer specializing in developing secure, efficient smart contracts and decentralized applications."
    },
    {
      name: "Nathan Hendrickx",
      email: "nathan.hendrickx@outlook.be",
      phone: "+32 471 234 567",
      function: "Ruby on Rails Developer",
      skills: ["Ruby", "Rails", "PostgreSQL", "RSpec"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Proficient Ruby on Rails developer with experience building maintainable, test-driven web applications."
    },
    {
      name: "Alice Dubois",
      email: "alice.dubois@gmail.com",
      phone: "+32 472 345 678",
      function: "API Developer",
      skills: ["RESTful API", "GraphQL", "Swagger", "API Design"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Methodical API developer specialized in creating well-documented, scalable APIs for enterprise applications."
    },
    {
      name: "Hugo Van Hove",
      email: "hugo.vanhove@hotmail.com",
      phone: "+32 473 456 789",
      function: "Integration Specialist",
      skills: ["ESB", "API Integration", "MuleSoft", "Message Queues"],
      manager: "Willem Van den Berg",
      status: "Open",
      ai_synthesis: "Skilled integration specialist with expertise in connecting disparate systems through various middleware and API solutions."
    },
    {
      name: "Emilie Janssens",
      email: "emilie.janssens@gmail.com",
      phone: "+32 474 567 890",
      function: "Tech Lead",
      skills: ["Team Leadership", "Architecture", "Code Review", "Mentoring"],
      manager: "Thomas De Vos",
      status: "Looking",
      ai_synthesis: "Experienced tech lead combining technical expertise with leadership skills to guide development teams to success."
    },
    {
      name: "Pierre Willems",
      email: "pierre.willems@outlook.be",
      phone: "+32 475 678 901",
      function: "Software Engineer",
      skills: ["Go", "Microservices", "Docker", "Kubernetes"],
      manager: "Sofie Martens",
      status: "Unavailable",
      ai_synthesis: "Versatile software engineer with strong backend skills and experience with containerization technologies."
    },
    {
      name: "Marie Vandenbroeck",
      email: "marie.vandenbroeck@gmail.com",
      phone: "+32 476 789 012",
      function: "UX Researcher",
      skills: ["User Interviews", "Usability Testing", "Personas", "Journey Mapping"],
      manager: "Lucas Vermeulen",
      status: "Open",
      ai_synthesis: "Empathetic UX researcher skilled at uncovering user needs through methodical research and testing approaches."
    },
    {
      name: "François Jacobs",
      email: "francois.jacobs@hotmail.com",
      phone: "+32 477 890 123",
      function: "Technical Architect",
      skills: ["Architecture Patterns", "Technical Roadmap", "Solution Design", "AWS"],
      manager: "Emma Claes",
      status: "Looking",
      ai_synthesis: "Strategic technical architect with a proven track record of designing elegant, scalable solutions for complex business problems."
    }
];
